import React, { useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import { dateFormatConDiaYHoraShort, getDate } from '../../utils/DateFunctions';
import jsPDF from 'jspdf';

const PDF_plan_consolidacion = (p) => {
    const width = 1100;
    const height = width * 1.294117647058824;
    const diaslow = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const [docs_by_page, setdocs_by_page] = useState(11);
    const [tipo_reporte, settipo_reporte] = useState('vivero');
    const [data, setdata] = useState([]);

    useEffect(() => {
        setdata(dividirArrayEnSubarrays(p.data, docs_by_page));
    }, [])

    const createPDF = async () => {
        p.loader(true);
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
        });

        for (let i = 0; i < data.length; i++) {
            let id = "hojaArr" + i;
            const componentRef = document.getElementById(id); // Reemplaza con el ID de tu componente
            console.log(componentRef, id);
            if (componentRef) {
                const canvas = await html2canvas(componentRef, { scale: 1.5 });
                const imgData = canvas.toDataURL('image/png');

                // Calcula el ancho y el alto de la imagen en el PDF
                const imgWidth = 215.9; // Ancho de la página en mm (A4)
                const imgHeight = 279.4;

                // Agrega la imagen como una nueva página al PDF
                if (i > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
        }

        // Guarda el PDF como un solo archivo
        doc.save('REP_' + p.type.toUpperCase() + "_" + p.data[0].semana_actual);
        p.loader(false);
    };

    function dividirArrayEnSubarrays(array, tamaño) {

        let subarrays = [];
        for (let i = 0; i < array.length; i += tamaño) {
            subarrays.push(array.slice(i, i + tamaño));
        }
        return subarrays;
    }

    const totales_bloque = (dt) => {
        let dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        let total_plan = 0;
        let total_ejecutado = 0;
        for (let i = 0; i < dias.length; i++) {
            total_plan += dt[`${dias[i]}p`];
            total_ejecutado += dt[`${dias[i]}e`];
        }
        return [total_plan, total_ejecutado];
    }

    const separador = () => { return (<span className="ms-2 me-2 text-900" style={{ color: "#BBBBBB" }}>|</span>) }

    const cambiar_reporte = () => {
        let rep = tipo_reporte === 'vivero' ? 'entrega de campo' : 'vivero';
        let docs = (rep === 'vivero') ? 11 : 50;
        settipo_reporte(rep);
        setdocs_by_page(docs);
        setdata(dividirArrayEnSubarrays(p.data, docs));
    }

    const numberFormat = (number) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return 0;
            return format;
        } catch (error) {
            return 0;
        }
    }


    const dias_sembrados = (dt) => {
        let count = [];
        for (let i = 0; i < diaslow.length; i++) {
            let d = diaslow[i] + '_ejecutado';
            if (numberFormat(dt[d]) > 0) count.push(i + 1);
        }

        return count.join(', ');
    }

    const total_ejecutado = (dt) => {
        let total = 0;
        for (let i = 0; i < dias.length; i++) {
            total += dt[`${dias[i]}e`];
        }
        return total;
    }

    return (
        <div className='col-lg-12 p-0 m-0'>
            <div className='row justify-content-evenly m-0 p-0 w-100 mt-5' style={{ position: "sticky", top: 0, zIndex: 9 }}>
                <div className='col-auto  text-center'>
                    <button className='btn btn-danger mt-2 shadow ps-5 pe-5 round-xxl' onClick={p.close} >Cerrar</button>
                </div>
                <div className='col-auto  text-center'>
                    <button className='btn btn-light mt-2 shadow round-xxl text-bold' onClick={cambiar_reporte}  >Cambiar a reporte de {tipo_reporte === 'vivero' ? 'entrega de campo' : 'vivero'}</button>
                </div>
                <div className='col-auto mt-2 text-center'>
                    <button className='btn btn-warning shadow round-xxl scale-continue-05 text-bold ps-5 pe-5' onClick={createPDF} >Descargar {data.length} hoja(s)</button>
                </div>
                <div className='col-lg-12'></div>
                {data.map((hoja, k) =>
                    <div key={"hoja aaa " + k} id={"hojaArr" + k} className={'bg-white text-center mt-5 mb-5 p-3 dosis' + (hoja.length === docs_by_page ? " contenedor" : "")}
                        style={{ minWidth: width, maxWidth: width, minHeight: height, maxHeight: height, border: "black solid 2px" }}>

                        {tipo_reporte === 'vivero' && <div className='row justify-content-evenly m-0 p-0 w-100'>
                            <div className='col-lg-12 text-end text-s text-300 p-0 m-0'>REPORTE DE CONSOLIDACIÓN PARA {tipo_reporte.toUpperCase()} - Fecha de creación:{dateFormatConDiaYHoraShort(getDate())}</div>

                            {hoja.map((json, i) =>
                                <div key={k + 'jfh' + i} className={'w-100 m-0 p-0 p-2 ' + (i < (docs_by_page - 1) ? "border-bottom border-dark" : "")}>
                                    <div className='row justify-content-evenly m-0 p-0 w-100'>
                                        <div className='w-40 text-l text-bold'>{json.bloque}</div>
                                        <div className='w-20 text-m'>
                                            <span className='text-s text-bold me-1'>Siembra</span>
                                            {json.semana_siembra}</div>
                                        <div className='w-20 text-m'>
                                            <span className='text-s text-bold me-1'>{p.type}</span>
                                            {json.semana_actual}
                                        </div>
                                        <div className='w-20 text-m'>
                                            <span className='text-s text-bold me-1'>transplante</span>
                                            {json.transplante}
                                        </div>
                                        <div className='col-lg-12 m-0 p-0'></div>
                                        {
                                            dias.map((dia, j) =>
                                                <div className={`text-center m-0 p-0`} key={j + dia + i}
                                                    style={{ width: '16%', borderLeft: j > 0 ? 'solid #CDCDCD 1px' : 'none' }}
                                                >
                                                    <div className='row justify-content-evenly w-100 m-0 p-0 '>
                                                        <div className='col-lg-12 m-0 p-0 text-center text-bold text-floricents'>{dia}</div>
                                                        <div className='w-30'>
                                                            <div className='w-100 text-xs text-bold text-center'>Plantado</div>
                                                            <div className='w-100' >{json[`${dia}`]}</div>
                                                        </div>
                                                        <div className='w-30'>
                                                            <div className='w-100 text-xs text-bold text-center'>Planeado</div>
                                                            <div className='w-100' >{json[`${dia}p`]}</div>
                                                        </div>
                                                        <div className='w-30'>
                                                            <div className='w-100 text-xs text-bold text-center'>Ejecutadoi</div>
                                                            <div className='w-100' >{json[`${dia}e`]}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className='col-lg-12 m-0 p-0'></div>
                                        <div className='text-s text-bold text-center m-0 p-0 ' style={{ width: "30%" }}>
                                            Ejecución de siembra
                                            <span className='text-m ms-1 text-400'>{json.total_ejecutado_charolas}</span>
                                            <span className='text-xs'> ch</span> {separador()}
                                            <span className='text-s text-400'>{json.por_germinacion}% GM plan</span>
                                        </div>
                                        <div className='text-s text-bold text-center m-0 p-0 ' style={{ width: "30%" }}>
                                            Planeado p.consolidación
                                            <span className='text-m ms-1 text-400'>{totales_bloque(json)[0]}</span>
                                            <span className='text-xs'> ch</span>{separador()}
                                            <span className='text-s text-400'>{json.germinacion_real}% GM DDS</span>
                                        </div>
                                        <div className='text-s text-bold text-center m-0 p-0 ' style={{ width: "30%" }}>
                                            Ejecutado p. consolidación
                                            <span className='text-m ms-1 text-400'>{totales_bloque(json)[1]}</span>
                                            <span className='text-xs'> ch</span>{separador()}
                                            <span className='text-s text-400'>{json.germinacion_consolidacion}% GM consolidación</span>
                                        </div>
                                        <div className={'text-s text-bold text-center m-0 p-0 contenedor ' + (json.aclimatado ? '' : 'opacity-30')} style={{ width: "37%" }}>
                                            {/*Aclimatado
                                            <span className='text-m ms-1 text-400'>{dateFormatConDiaYHoraShort(json.aclimatado, "No aclimatado")}</span>*/}
                                        </div>
                                    </div>
                                </div>
                            )
                            }
                        </div>}
                        {tipo_reporte !== 'vivero' && <div className='row justify-content-evenly m-0 p-0 w-100 text-s'>
                            <div className='text-white bg-dark  contenedor text-xs m-0' style={{ width: '3%' }}>Cont.</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '21%' }}>Flor varidad color</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '9%' }}>Sem corte</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '9%' }}>PPTO</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '8%' }}>Sem. siembra</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '9%' }}>Día(s) siembra</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '7%' }}># Charolas</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '8%' }}>CV. Charolas</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '8%' }}>GM. consolidación</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '9%' }}>Plantas reales</div>
                            <div className='text-white bg-dark  contenedor m-0' style={{ width: '9%' }}>Diferencia Real - PPTO</div>

                            {
                                hoja.map((dt, i) => <React.Fragment key={'datarr ' + i} >
                                    <div className={`text-xs text-black border contenedor text-xs m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '3%' }}>{k * docs_by_page + i + 1}</div>
                                    <div className={`text-s text-black border contenedor-left ps-2 m-0 text-bold ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '21%' }}>{dt.bloque}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '9%' }}>{dt.semanaCosecha}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '9%' }}>{Math.floor(numberFormat(dt.plantas))}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '8%' }}>{dt.semana_siembra}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '9%' }}>{dias_sembrados(dt)}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '7%' }}>{Math.floor(numberFormat(dt.charolas_cosolidadas ?? 0))}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '8%' }}>288</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '8%' }}>{dt.germinacion_consolidacion}%</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'}`} style={{ width: '9%' }}>{Math.floor(numberFormat(dt.plantas_reales ?? 0))}</div>
                                    <div className={`text-m text-black border contenedor m-0 ${(i % 2 === 0) ? 'bg-white' : 'bg-ligt-grey'} ${Math.floor(numberFormat((dt.plantas_reales ?? 0) - (dt.plantas ?? 0))) < 0 ? 'text-danger' : 'text-black'}`} style={{ width: '9%' }}>{Math.floor(numberFormat((dt.plantas_reales ?? 0) - (dt.plantas ?? 0)))}</div>
                                </React.Fragment>
                                )
                            }
                        </div>
                        }
                    </div>)}
            </div>
        </div>
    )
}

export default PDF_plan_consolidacion;